<div class="title-container">
    <div class="item">
        <span class="title">{{ 'LAYOUT_ONE.segment' | translate }}</span>
        <span class=""> {{ flight.origin.cityName }} - {{ flight.destination.cityName }}</span>
    </div>
    <div class="item">
        <div class="icon-flight"></div>
        <!-- <span class="text">Ida</span> -->
    </div>
</div>